<template>
<main class="has-breadcrumbs">
    <h1>Home</h1>
    <ul>
        <li><router-link to="search">Search (en)</router-link></li>
        <li><router-link to="rechercher">Chercher (fr)</router-link></li>
    </ul>
</main>
</template>

<script>
export default {
    name: 'home',
    components: {

    }
}
</script>
